import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../api/Axiosinstance';

export const useSignin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const signin = async (email, password, rememberMe = false) => {
    try {
      setLoading(true);
      setError(null);

      // Make API call using axios instance
      const response = await axiosInstance.post('/auth/login', {
        email,
        password,
        rememberMe
      });

      // Handle successful login
      const { token, user } = response.data;
      
      // Store token (adjust storage method based on rememberMe)
      if (rememberMe) {
        localStorage.setItem('authToken', token);
        localStorage.setItem('user', JSON.stringify(user));
      } else {
        sessionStorage.setItem('authToken', token);
        sessionStorage.setItem('user', JSON.stringify(user));
      }

      // Set axios default header for future requests
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;

      // Navigate to dashboard or home page
      navigate('/dashboard'); // Adjust route as needed

      return { success: true, data: response.data };

    } catch (err) {
      const errorMessage = err.response?.data?.message || 
                          err.response?.data?.error || 
                          'Login failed. Please try again.';
      
      setError(errorMessage);
      return { success: false, error: errorMessage };

    } finally {
      setLoading(false);
    }
  };

  const googleSignin = async () => {
    try {
      setLoading(true);
      setError(null);

      // Handle Google OAuth flow
      // This could redirect to your backend OAuth endpoint
    //   window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
      
    } catch (err) {
      setError('Google login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const appleSignin = async () => {
    try {
      setLoading(true);
      setError(null);
    //   window.location.href = `${process.env.REACT_APP_API_URL}/auth/apple`;
      
    } catch (err) {
      setError('Apple login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    signin,
    googleSignin,
    appleSignin,
    loading,
    error,
    clearError
  };
};